


export function zeroPadding(num: number, qty: number): string {
  return `${"0".repeat(qty)}${num}`.slice(qty * -1);
}